import {
  React,
  useState,
  Button,
  useNavigate,
  Link,
  useParams,
  useEffect,
  Modal,
  useLocation,
  useRef,
} from "../utils/thirdpartyComponents";
import CWFooter from "src/components/CWFooter";
import { BayApi, SubscriptionandwashpriceApi } from "src/utils/apiUrls";
import axios from "../config/axiosConfig";
import { ISelfServeSubscriptionDetails } from "src/interfaces/subscriptionInterface";
import moment from "moment";
import { MessageToaster } from "src/utils/toastUtil";
import SmallLoader from "src/components/SmallLoader";
import { pageURLs } from "src/utils/pageUrls";
import { toast } from "react-toastify";
import { SELF_SERVE_BAY_BUSY_ERROR, SELF_SERVE_BAY_OUTOFSERVICE_ERROR } from "src/utils/constants";
import { bayTypeLabelMap, EquipmentType, EquipmentTypeId, ServiceType } from "src/utils/enums";
import { formatMinutesToMinutesSeconds } from "src/utils/helper";

const SelfService = () => {
  const continueModalShownRef = useRef(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const [subscriptionData, setsubscriptionData] =
    useState<ISelfServeSubscriptionDetails>();
  const [showModal, setShowModal] = useState(false);
  const [timer, setTimer] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
  const [timeLimit, setTimeLimit] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [scan, setScan] = useState(0);
  const [referralSingleWash, setReferralSingleWash] = useState(false);
  const [showContinueModal, setShowContinueModal] = useState(false);
  const [continueConfirmed, setContinueConfirmed] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [purchaseConfirmed, setPurchaseConfirmed] = useState(false);
  const [bayName,setBayName] = useState('');
  const [actualTime, setActualTime] = useState(0);
  const [bayId, setBayId] = useState(0);
  const [userSubscriptionID, setUserSubscriptionID] = useState(0);
  const [startTime, setStartTime] = useState<number | null>(null);
  const [userChoseToContinue, setUserChoseToContinue] = useState(false);
  const [showSinleWashCancelConfirmation, setSinleWashCancelConfirmation] = useState(false);
  // const [subscriptionBayType,setSubscriptionBayType] = useState(1);

  const location = useLocation();
  const toaster = new MessageToaster();
  const queryParams = new URLSearchParams(location.search);
  const activewash = queryParams.get("activewash");
  const navigate = useNavigate();
  const stopTriggeredRef = useRef(false);
  const continueConfirmedRef = useRef(false);
  const purchaseConfirmedRef = useRef(false);
  const isRedirecting = useRef(true);
  const params = useParams();
  const maxWAshTime = 600
  const bulkwashMaxTime = 1800
  const freeVacuum = queryParams.get('freeVacuum') ?? 'false'
  const freeSelfServe = queryParams.get('freeSelfServe') ?? 'false'
  const bayTypeId = queryParams.get('bayTypeId') ?? null
  const beforeMAxWashTime = (bayTypeId==EquipmentType.SelfServe) ? 840 : 540 // 9 min

  useEffect(() => {
    if (location?.state?.redirectedFromFooter) {
    setUserSubscriptionID(location.state.UserSubscriptionID);
    setBayId(location.state.bayId);
  } else if (location?.state?.UserSubscriptionID && location?.state?.bayId) {
    setUserSubscriptionID(location.state.UserSubscriptionID);
    setBayId(location.state.bayId);
  } else {
    getUserActiveWashdetails();
  }

    return () => {
      // if (intervalId) clearInterval(intervalId);
      if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
      setsubscriptionData({});
      stopTriggeredRef.current = false;
    };
  }, []);



  const calculateElapsed = (start: number) =>
    Math.floor((Date.now() - start) / 1000);

  const startTimer = (startTimestamp: number, subscription?: ISelfServeSubscriptionDetails) => {
  stopTriggeredRef.current = false;
    console.log("subscription",subscription)
  if (intervalRef.current) {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }

  setStartTime(startTimestamp);
    // if (intervalId) {
    //   clearInterval(intervalId); 
    // }
     setStartTime(startTimestamp);

    const sub = subscription;
    const isSingleWash = sub?.subscriptionType === 1;
    const isReferral = sub?.referralSingleWash;
    const hasVacuumWash = sub?.hasVacuumWash;
    const hasSelfService = sub?.hasSelfService;
    const isExtended = sub?.isExtended === 1;

    // const originalDuration = Number(sub?.washTimeRemaining ?? '0') * 60;
    // const originalDuration = (sub?.bayTypeID == EquipmentType.SelfServe) ? 900 : Number(sub?.washTime ?? 0) * 60;
    const originalDuration =
  sub?.bayTypeID !== undefined && sub.bayTypeID ==EquipmentTypeId["Self Serve"] 

    ? 900
    : Number(sub?.washTime ?? 0) * 60;
    const SubscriptionRemainingTime = Number(sub?.washTimeRemaining ?? 0) * 60
    let maximumWashTime = maxWAshTime;
    if(sub?.subscriptionType === 3)
    {
     maximumWashTime = bulkwashMaxTime

    }
    else{
     maximumWashTime = sub?.bayTypeID !== undefined && sub.bayTypeID ==EquipmentTypeId["Self Serve"] ? 900 : maxWAshTime

    }
    const subscriptionWashEndTime = SubscriptionRemainingTime < maximumWashTime ? SubscriptionRemainingTime : maximumWashTime;
    let  totalDuration = 0;
    if(freeVacuum == 'true' && hasVacuumWash==1)
    {
      totalDuration = Number(sub?.maxVacuumTime ?? 0) * 60
    }
    else if(freeSelfServe == 'true' && hasSelfService==1)
    {
      totalDuration = Number(sub?.maxSelfServiceTime ?? 0) * 60
    }
    else{
      totalDuration = isSingleWash ? (isExtended ?  maxWAshTime: originalDuration) : subscriptionWashEndTime ;
    }
    intervalRef.current = setInterval(() => {
      // const elapsed = Math.floor((Date.now() - startTimestamp) / 1000);
      const elapsed = Math.max(0, Math.floor((Date.now() - startTimestamp) / 1000));
      setTimer(elapsed);

      if (
        isSingleWash &&
        !isReferral && freeVacuum!='true' && freeSelfServe!='true' &&
        (Number(sub.bayTypeID)!=EquipmentTypeId["Self Serve"]) && 
        totalDuration <= beforeMAxWashTime &&
        !continueConfirmedRef.current &&
        elapsed === originalDuration - 60 &&
        !continueModalShownRef.current && sub?.canExtentSingleWash != 0
      ) {
        continueModalShownRef.current = true;
        // clearInterval(id);
        setShowContinueModal(true);
        return;
      }
      

      if (!isSingleWash && elapsed === SubscriptionRemainingTime && !showPurchaseModal && freeVacuum!='true' && freeSelfServe!='true') {
        isRedirecting.current = false
        setShowPurchaseModal(true);
      }

      if (elapsed >= totalDuration) {
        // clearInterval(id);
        clearInterval(intervalRef.current!);
      intervalRef.current = null;
        setIsRunning(false);
        setActualTime(elapsed);
        handleStop(elapsed);
      }
    }, 1000);

    // setIntervalId(id);
  };

  const getUserActiveWashdetails = async () => {
    try {
      const { data } = await axios.get(BayApi.GET_ACTIVE_WASH);
      if (
        data?.error === 0 &&
        data?.data?.userSubscriptionID > 0 &&
        data?.data?.bayID > 0
      ) {
        setUserSubscriptionID(data.data.userSubscriptionID);
        setBayId(data.data.bayID);
      }
    } catch (error: any) {
      console.log(error.response?.data?.message);
    }
  };

  useEffect(() => {
    if (userSubscriptionID && bayId) {
      getBayDetails();
    }
  }, [userSubscriptionID, bayId]);

  const fetchSubscriptionDetails = async () => {
    try {
      const { data } = await axios.get(
        `${SubscriptionandwashpriceApi.GET_SUBSCRIPTION_BY_ID}/${userSubscriptionID}/${bayId}`
      );
      if (data?.error === 0) {
        setsubscriptionData(data?.data);
        setReferralSingleWash(data?.data?.referralSingleWash);
        let bayName = getBayLabel(data?.data)
        setBayName(bayName)
        return data.data;
      }
    } catch (error: any) {
      console.log(error.response?.data?.message);
    }
  };

  const getBayDetails = async () => {
    setLoading(true);
    const updated = await fetchSubscriptionDetails();
    if (!updated) return;
    let minutes;
    if(freeVacuum == 'true')
    {
      minutes = Number(updated?.maxVacuumTime);
    }
    else if(freeSelfServe == 'true')
    {
      minutes = Number(updated?.maxSelfServiceTime);

    }
    else{
      minutes = Number(updated?.washTimeRemaining);
    }
    // const minutes = parseInt(updated?.washTimeRemaining);
    const activeWashSec = parseInt(updated?.activeWashTimeSec);
    // setSubscriptionBayType(updated?.subscriptionBayType)
    setLoading(false);
    if (activeWashSec > 0 && updated?.washEndTime==null) {

      setIsRunning(true);
      const startTs = updated.washStartTime
        ? updated.washStartTime * 1000
        : Date.now() - activeWashSec * 1000;

      startTimer(startTs, updated);
      setsubscriptionData(updated);


    }

    if (!isNaN(minutes)) {
      setTimeLimit(minutes * 60);
    }
  };




  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const getMaxWashMinutes = () =>
    subscriptionData?.bayTypeID == EquipmentTypeId["Self Serve"] ? 15 : 10;

  const getPreAuthAmount = () => {
    const apiPreAuth = Number(subscriptionData?.preAuthAmount);
    if (
      subscriptionData?.preAuthAmount != null &&
      !isNaN(apiPreAuth) &&
      apiPreAuth > 0
    ) {
      return apiPreAuth;
    }
    const price = Number(subscriptionData?.price ?? 0);
    const washTime = Number(subscriptionData?.washTime ?? 0);
    const priceForExtraTime = Number(subscriptionData?.PriceForExtraTime ?? 0);
    const extraMinutes = Math.max(0, getMaxWashMinutes() - washTime);
    return price + extraMinutes * priceForExtraTime;
  };

  const handleStartClick = () => {
    if (!bayId) {
      toaster.toastError("Please select bay");
      navigate(`/${params.carwashname}/${pageURLs.home}`);
      return;
    }
    setShowModal(true);
  };


  const confirmStart = async () => {
    if (
      subscriptionData?.subscriptionType === 1 &&
      freeVacuum !== "true" &&
      freeSelfServe !== "true" 
      // &&
      // subscriptionData?.canExtentSingleWash != 0 
    ) {
      const preAuthAmount = getPreAuthAmount().toFixed(2);
      const maxWashMinutes = getMaxWashMinutes();
      const giftCardUsed = subscriptionData?.isGiftCardUsed === true || Number(subscriptionData?.isGiftCardUsed) === 1;
      const holdMessage = giftCardUsed
        ? `We will place a temporary hold of $${preAuthAmount} to cover your wash and up to ${maxWashMinutes} extra minutes. Your gift card will be used first and your credit card will cover the rest. You will be charged only for the time you use.`
        : `We will place a temporary hold of $${preAuthAmount} to cover your wash and up to ${maxWashMinutes} extra minutes. You will be charged only for the time you use.`;
      toaster.toastSuccessLong(holdMessage);
    }
    setIsRunning(true) // recheck
    setLoading(true);
    setShowModal(false);

    const response = await deviceStart();

    if (
      response?.deviceStatus === true &&
      response?.bayStatus === 1 &&
      response?.washStartStatus === true
    ) {
      const updated = await fetchSubscriptionDetails();
      setLoading(false);
      setIsRunning(true);

      if (updated) {
          // const startTs = updated.washStartTime
          //   ? updated.washStartTime * 1000
          //   : Date.now() - parseInt(updated.activeWashTimeSec) * 1000;
          const startTs = updated.washStartTime
          ? updated.washStartTime * 1000
          : Date.now() - parseInt(updated.activeWashTimeSec ?? 0) * 1000
        startTimer(startTs, updated); 
      }
    }
  };

  const extendSingleWashTime = async () => {
    const requestData = { userSubscriptionId: userSubscriptionID };
    try {
      const res = await axios.post(BayApi.SELF_SERVE_EXTEND, requestData);
      if (res?.data?.error === 0) return res?.data?.data;
      toaster.toastError(res?.data?.message);
    } catch (error) {
      console.log(error);
    }
  };

  const handleContinueYes = async () => {
    continueConfirmedRef.current = true;
    setContinueConfirmed(true);
    continueModalShownRef.current = false;
    setShowContinueModal(false);
    toaster.toastSuccess(`The ${subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum? "vacuum":"wash"} time will be extended after your default ${subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum? "vacuum":"wash"} time.`)

    // 1. Tell backend to extend
    await extendSingleWashTime();

    const updated = await fetchSubscriptionDetails();
    if (updated) {
      const startTs = updated.washStartTime
        ? updated.washStartTime * 1000
        : Date.now() - Number(updated.activeWashTimeSec ?? 0) * 1000;

      startTimer(startTs, updated); // 
    }
  };


  const handleStop = async (actualTime: number) => {
    if (stopTriggeredRef.current) 
      {
        return;
      }
    stopTriggeredRef.current = true;
  if (intervalRef.current) {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }

    // if (intervalId) clearInterval(intervalId);
    setIsRunning(false);
    setLoading(true);

    if (userSubscriptionID > 0 && bayId > 0 && actualTime > 0) {
      const start_response = await deviceStop(actualTime);
      if (start_response?.data) {
        setLoading(false);
        // setTimeout(() => {
          if(isRedirecting.current === true)
          {
            toaster.toastSuccess(`The ${subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum? "vacuum":"wash"} has been completed.`)
            navigate(`/${params.carwashname}/${pageURLs.home}`);

          }
        // }, 3000);
      } else {
        navigate(`/${params.carwashname}/${pageURLs.home}`);
      }
    }
  };


  const handleCancelModal = () => setShowModal(false);

  const getUpperLimitInMinutes = (seconds: number) =>
    Number((seconds / 60).toFixed(2));

  const deviceStart = async () => {
    const requestData = {
      bayId: Number(bayId),
      userSubscriptionId: userSubscriptionID,
      scan: scan,
      // subscriptionBayType: subscriptionBayType
    };
    try {
      const response = await axios.post(BayApi.SELF_SERVE_START, requestData);
      if (response?.data?.error === 0) 
        {return response?.data?.data;}
      else{
        if(response?.data?.error ===SELF_SERVE_BAY_BUSY_ERROR)
        {
            navigate("/" + params.carwashname + "/" + pageURLs.statusbusy+`?scan=`+scan+"&washType="+subscriptionData?.subscriptionType+"&isBayTunnel=false", { state: { selectedBayId: localStorage.getItem('selectedBay') ,washName:subscriptionData?.washName,bayNameText:bayName} });
        }
        else if(response?.data?.error ===SELF_SERVE_BAY_OUTOFSERVICE_ERROR)
        {
           navigate("/" + params.carwashname + "/" + pageURLs.statusoutofservice);
        }
        else{
          toaster.toastError(response?.data?.message);
          navigate(`/${params.carwashname}/${pageURLs.home}`);
        }
        
      }
      
    } catch (error) {
      console.log(error);
    }
  };

  const deviceStop = async (timeTaken: number) => {
    const requestData = {
      bayId: Number(bayId),
      userSubscriptionId: userSubscriptionID,
      actualWashTime: getUpperLimitInMinutes(timeTaken),
    };
    try {
      const res = await axios.post(BayApi.SELF_SERVE_STOP, requestData);
      if (res?.data?.error === 0) return res?.data;
      toaster.toastError(res?.data?.message);
    } catch (error) {
      console.log(error);
    }
  };


  const purchaseRedirect = () =>{
    setPurchaseConfirmed(true);
    purchaseConfirmedRef.current = true;
    setShowPurchaseModal(false);
    navigate(
          `/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&bayselect=true&fromTab=singlewash&bayTypeId=${bayTypeId}`,
          { state: { bayId: bayId } }
        );
   
  }

  function getBayLabel(item: any): string {
  if (item.bayName) return item.bayName;
  if (item.bayTypeID && item.bayNumber) {
    return `${bayTypeLabelMap[item.bayTypeID] || "Unknown"} ${item.bayNumber}`;
  }
  return "Unknown";
}

  const getSingleWashBayType = () => {
    if (bayTypeId !== null && bayTypeId !== "") {
      const parsedBayType = Number(bayTypeId);
      if (!Number.isNaN(parsedBayType)) return parsedBayType;
    }
    switch (subscriptionData?.bayTypeID) {
      case EquipmentTypeId["Dog Wash"]:
        return ServiceType.dogWash;
      case EquipmentTypeId.Vacuum:
        return ServiceType.vacuumWash;
      case EquipmentTypeId.Tunnel:
      case EquipmentTypeId["In Bay"]:
        return ServiceType.bayTunnel;
      default:
        return ServiceType.selfServe;
    }
  };

  const cancelSingleWashCancellation = () => {
    setSinleWashCancelConfirmation(false);
  };

  const cancelSinglewashConfirm = () => {
    setSinleWashCancelConfirmation(true);
  };

  const cancelSingleWash = async () => {
    const selectedBay = bayId || localStorage.getItem("selectedBay");
    try {
      setLoading(true);
      const responseSingleWash = await axios.get(
        SubscriptionandwashpriceApi.CANCEL_SINGLE_WASH +
          "?bayId=" +
          selectedBay +
          "&bayType=" +
          getSingleWashBayType()
      );

      if (responseSingleWash?.data?.error === 0) {
        setSinleWashCancelConfirmation(false);
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        setIsRunning(false);
        setLoading(false);
        toaster.toastSuccess(responseSingleWash?.data?.message);
        navigate("/" + params.carwashname + "/" + pageURLs.home);
      } else {
        setLoading(false);
        setSinleWashCancelConfirmation(false);
        toaster.toastError(responseSingleWash?.data?.message);
      }
    } catch (error: any) {
      setLoading(false);
      setSinleWashCancelConfirmation(false);
      toaster.toastError(error.response?.data?.message || error.message);
    }
  };

  const canCancelSingleWash =
    subscriptionData?.subscriptionType === 1 &&
    freeVacuum !== "true" &&
    freeSelfServe !== "true";

  return (
    <div className="common-content-wrap pb-70">
      <div className="inner-content-wrap">
        <div className="common-header two-block-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner">{subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum? "Active Vacuum / Other" :"Active Wash"}</div>
          </div>
        </div>
        <div className="main-content-wrap pe-0 ps-0 pt-0">
          <div className="my-subscription-wrap timer-section-wrap">
            <div className="cw-card">
              <div className="cw-card-content">
                <div className="cw-card-leftcontent">
                  {/* <h6>{subscriptionData?.washName}</h6> */}

                  <h6 className="name"><span>{subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum? "Vacuum name":"Wash name" }:</span> {subscriptionData?.washName}</h6>
                  <h6 className="name"><span>Bay name :</span> {bayName}</h6>
                </div>
                <div className="cw-card-rightcontent">
                  <div className="cw-card-value">
       
                    {subscriptionData
                    ? (freeVacuum === 'true' || freeSelfServe==='true'
                        ? "Free" 
                        : '$' + (subscriptionData?.price?.toFixed(2) ?? "0.00"))
                    : ""}
                    {/* <span className="decimal-sec">.00</span> */}
                  </div>
                  {subscriptionData?.subscriptionType === 2 ? <div className="cw-card-smalltext">Per Month</div> : <div className="cw-card-smalltext cw-min-text">till {freeVacuum=='true' ? subscriptionData?.maxVacuumTime : freeSelfServe=='true' ? subscriptionData?.maxSelfServiceTime : parseFloat(Number(subscriptionData?.washTimeRemaining).toFixed(2))} Min</div>}
                </div>
              </div>
              
              <div className="cw-card-validity d-flex justify-content-center">
              { subscriptionData?.subscriptionType === 3 ? 
              <>
                <div className="info-block text-center">
                  <p>Minutes Remaining</p>
                  <span>{formatMinutesToMinutesSeconds(subscriptionData?.hasVacuumWash && freeVacuum=='true' ? subscriptionData?.maxVacuumTime : subscriptionData?.hasSelfService && freeSelfServe=='true' ? subscriptionData?.maxSelfServiceTime : subscriptionData?.washTimeRemaining)}</span>
                </div> 
             
                {subscriptionData?.minimumRunTime && subscriptionData?.minimumRunTime > 0 ? <div className="info-block text-center">
                  <p>Min Run Time</p>
                  <span>
                   {subscriptionData.minimumRunTime} Min
                  </span>
                </div> : null}
                </>:
              subscriptionData?.subscriptionType === 2  ?
              <>
                <div className="info-block text-center">
                  <p>Minutes Remaining</p>
                  <span>{formatMinutesToMinutesSeconds(subscriptionData?.hasVacuumWash && freeVacuum=='true' ? subscriptionData?.maxVacuumTime : subscriptionData?.hasSelfService && freeSelfServe=='true' ? subscriptionData?.maxSelfServiceTime : subscriptionData?.washTimeRemaining)}</span>
                </div> 
                <div className="info-block text-center">
                  <p>Valid Till</p>
                  <span>
                    {subscriptionData?.endDate
                      ? moment(subscriptionData.endDate).format("MM/DD/YYYY")
                      : ""}
                  </span>
                </div>
                {subscriptionData?.minimumRunTime && subscriptionData?.minimumRunTime > 0 ? <div className="info-block text-center">
                  <p>Min Run Time</p>
                  <span>
                   {subscriptionData.minimumRunTime} Min
                  </span>
                </div> : null}
                </>:freeVacuum!='true' && freeSelfServe!='true' && subscriptionData?.canExtentSingleWash != 0 ? <p className="fw-bold py-3">
                  ${subscriptionData?.PriceForExtraTime} for Extra Usage per
                  Minute
                </p>:""}

                </div>
            </div>
         {subscriptionData?.subscriptionType === 1 && freeVacuum!='true' && freeSelfServe!='true' && (subscriptionData?.canExtentSingleWash != 0)  ? (
              subscriptionData?.bayTypeID==EquipmentTypeId["Self Serve"] ?  <div className="payment-alert text-center">
                  <p className="fw-medium"> The wash time will automatically count up to a maximum of 15 minutes. You will be charged for each additional minute used.  Please remember to hit the stop button when you complete your wash. </p>
                  </div> :subscriptionData?.washTimeRemaining && Number(subscriptionData?.washTimeRemaining) < 10 ?  <div className="payment-alert text-center">
                <p className="fw-medium">{`This ${subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"vacuum":"wash"} time will automatically stop after ${parseFloat(Number(subscriptionData?.washTimeRemaining).toFixed(2))} minutes. A prompt to extend the ${subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"vacuum":"wash"} time will be shown 1 minute before the default ${subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"vacuum":"wash"} time ends. Please keep watch.`}</p>
                </div> :""              
            ) : ""} 
            <div className="timer-block text-center">
              <div className="timer">{formatTime(timer)}</div>
              <p>{subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"Please tap on your stop button when finished.":"Please tap on Stop button once your wash is over."}</p>
            </div>
            <div className="btn-sec d-flex flex-column">
              <Button
                variant="secondary"
                type="button"
                className="secondary-btn btn-main"
                onClick={handleStartClick}
                disabled={isRunning }
              >
                Start
              </Button>
              <Button
                variant="primary"
                type="button"
                className="primary-btn btn-main"
                onClick={() => handleStop(timer)}
                disabled={!isRunning }
              >
                Stop
              </Button>
              {canCancelSingleWash ? (
                  <Button
                    variant="primary"
                    type="button"
                    className="primary-btn btn-main"
                    onClick={cancelSinglewashConfirm}
                  >
                    Cancel
                  </Button>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {loading ? <SmallLoader /> : ""}

      <Modal show={showModal} onHide={handleCancelModal} centered className="notification-modal">
        <Modal.Body className="text-center">
          <p>
            {subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum? "Is the equipment ready to use? ":"Is the  bay ready to use? "}
         
          </p>
        </Modal.Body>
        <Modal.Footer className="d-grid">
          <Button variant="secondary" onClick={handleCancelModal} className="secondary-btn m-0">
            No
          </Button>
          <Button variant="primary" onClick={confirmStart} className="primary-btn btn-main m-0">
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showContinueModal} 
     
       onHide={() => setShowContinueModal(false)} className="notification-modal"

        centered>
        <Modal.Body className="text-center" >
          <h5 className="mb-2">Continue {subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"vacuum":"wash"}</h5>
          <p>
          The default {subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"vacuum":"wash"} time will end soon. Would you like to extend the {subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"vacuum":"wash"} time? You will be charged per minute of usage.          </p>
        </Modal.Body>
        <Modal.Footer className="d-grid">
          <Button variant="secondary" onClick={() => setShowContinueModal(false)} className="m-0 secondary-btn">
            No
          </Button>
          <Button variant="primary" onClick={handleContinueYes} className="primary-btn btn-main m-0">
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal

        show={showPurchaseModal}

        onHide={() => setShowPurchaseModal(false)}
        backdrop="static"   // Prevents closing by clicking outside
        keyboard={false}   

        centered

        className="notification-modal"

      >
        <Modal.Body className="text-center">
          <h5 className="mb-2">Buy Subscription</h5>
          <p>
          The {subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"vacuum":"wash"} time available in your subscription has ended. Would you like to purchase a single {subscriptionData?.bayTypeID==EquipmentTypeId.Vacuum?"use":"wash"} and continue?          </p>
        </Modal.Body>
        <Modal.Footer className="d-grid">
          <Button variant="secondary" onClick={() =>       navigate(`/${params.carwashname}/${pageURLs.home}`)} className="m-0 secondary-btn"

          >
            No
          </Button>
          <Button
            variant="primary"
            onClick={() =>purchaseRedirect()}
            className="primary-btn btn-main m-0"
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSinleWashCancelConfirmation}
        onHide={cancelSingleWashCancellation}
        centered
        className="notification-modal"
      >
        <Modal.Body className="text-center">
          <h6>
            Are you sure you want to cancel this single{" "}
            {subscriptionData?.bayTypeID == EquipmentTypeId.Vacuum ? "use" : "wash"}?
          </h6>
        </Modal.Body>
        <Modal.Footer className="d-grid">
          <Button variant="light" className="m-0" onClick={cancelSingleWashCancellation}>
            No
          </Button>
          <Button variant="primary" className="primary-btn btn-main m-0" onClick={cancelSingleWash}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <CWFooter activeLink="Home" />
    </div>
  );
};

export default SelfService;
